/**
 * Shelf entity class
 */

import { SHELF_LOCALIZATION_PAIRS, metadataMapToLocalizations, localizationsToMetadataMap } from 'app/helpers/localization'

/**
 * ShelfFactory
 * returns Shelf entity class
 *
 * @class ShelfFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Shelf} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ShelfFactory
 */
/* @ngInject */
export default function ShelfFactory ($injector, $sce, $http, Type, Entity, alertLiteSvc, onOffMixin) {
  /* === Shelf class === */

  /**
   * Shelf model
   *
   * @class Shelf
   * @classdesc Shelf model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.Shelf} Shelf entity
   */
  function Shelf () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Shelf.prototype = Object.create(Entity.prototype)
  Shelf.prototype.constructor = Shelf

  /* === Shelf instance methods & fields === */

  Object.assign(Shelf.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Shelf#
     * @type {Object}
     */
    _fields: {
      $action: String,
      $autoIdentifier: Boolean,
      $formStatus: String,
      $fromCategory: Boolean,
      $is_open: Boolean,
      contentType: String, //
      deeplinkIdentifier: String,
      description: String,
      id: Number,
      networkId: Number,
      slots: ['Slot'],
      sortingRuleName: String,
      title: String,
      localizationMetadata: {} // map<langCode, {title, description}>
    },

    /**
     * url template
     *
     * @memberof models.Shelf#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/carousels/shelf/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.Shelf#
     * @type {String}
     */
    _publicUrlTemplate: 'networks/{{::networkId}}/carousels/shelf/{{::id}}',

    /**
     * Prepare note
     *
     * @memberof models.Shelf#
     * @override
     */
    _prepare: function () {
      this.localizations = metadataMapToLocalizations(this.localizationMetadata, SHELF_LOCALIZATION_PAIRS)
    },

    /**
     * Get underlying object
     *
     * @memberof models.Shelf#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      if (this.$autoIdentifier) {
        this.deeplinkIdentifier = ''
      }
      this.localizationMetadata = localizationsToMetadataMap(this.localizations, SHELF_LOCALIZATION_PAIRS)
      return Entity.prototype._object.apply(this, arguments)
    },

    /**
     * Load content for carousels according type
     *
     * @memberof models.FeaturedCarousel#
     * @return {Object[]}
     */
    _loadItems: function (params) {
      return $http.get(`/nora/api/networks/${this.networkId}/carousels/shelf/extra`, { params }).data()
        .then((response) => response.payload)
    }

  }, onOffMixin)

  /* === Shelf static methods & fields === */

  /**
   * Create a new Shelf
   *
   * @param {Shelf} data - данные для создания Shelf
   * @return {Promise} promise
   */
  Shelf._create = function (data) {
    return $http.post(`api/networks/${data.networkId}/carousels/shelf`, data._object())
      .then((response) => response.data)
  }

  /**
   * Удалить Shelf
   *
   * @param {Shelf} data - ID shelf
   * @return {Promise} promise
   */
  Shelf._delete = function (data) {
    return $http.delete(`api/networks/${data.networkId}/carousels/shelf/${data.id}`)
      .then((response) => response.data)
  }

  /**
   * Обновить Shelf
   *
   * @param {Shelf} data - объект shelf с обновленными данными
   * @return {Promise} promise
   */
  Shelf._update = function (data) {
    return $http.put(`api/networks/${data.networkId}/carousels/shelf/${data.id}`, data._object())
      .then((response) => response.data)
  }

  /**
   *
   * @return {Promise} promise
   * @param pckgId
   * @param params
   */
  Shelf._getCategories = function (pckgId, params) {
    return $http.get(`api/networks/${pckgId}/carousels/shelf/categories`, { params })
      .then((response) => response.data)
      .then((data) => data.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   *
   * @return {Promise} promise
   * @param pckgId
   * @param categoryId
   * @param params
   */
  Shelf._getShelfFromCategory = function (pckgId, categoryId, params) {
    return $http.get(`api/networks/${pckgId}/carousels/shelf/template/category/${categoryId}`, { params })
      .then((response) => response.data)
      .then((data) => data.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  // copy all static methods from Entity class
  Object.assign(Shelf, Entity)
  Shelf._name = 'Shelf'
  Shelf.init()

  // permissions
  Shelf.access = {
    // view: 'viewShelfCarousel',
    // edit: 'editShelfCarousel',
    // create: 'editShelfCarousel',
    // delete: 'deleteShelfCarousel'
  }

  return Shelf
}
